(() => {
  if (window.noshemetCollectionEditorReady) return;
  window.noshemetCollectionEditorReady = true;
  const instances = new WeakMap();
  function init(root) {
  if (!root || instances.has(root)) return;
  const controller = new AbortController();
  let observer;
  instances.set(root, () => { controller.abort(); observer?.disconnect(); for (const motion of moving.values()) motion.cancel(); });
  const cards = [...root.querySelectorAll('[data-ns-card]')];
  const needButtons = [...root.querySelectorAll('button[data-ns-need]')];
  const skinButtons = [...root.querySelectorAll('button[data-ns-skin]')];
  const count = root.querySelector('[data-ns-count]');
  const empty = root.querySelector('[data-ns-empty]');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const moving = new Map();
  const revealed = new WeakSet();
  function animate(element, frames, delay = 0, duration = 280) {
    if (reducedMotion.matches || !element.animate) return;
    moving.get(element)?.cancel();
    const motion = element.animate(frames, { duration, delay, easing: 'cubic-bezier(0.23, 1, 0.32, 1)', fill: 'backwards' });
    moving.set(element, motion);
    const done = () => { if (moving.get(element) === motion) moving.delete(element); };
    motion.onfinish = done;
    motion.oncancel = done;
  }
  const enter = [{ opacity: 0, transform: 'translateY(24px)' }, { opacity: 1, transform: 'translateY(0)' }];
  reducedMotion.addEventListener('change', () => {
    for (const motion of moving.values()) motion.cancel();
    moving.clear();
  }, {signal: controller.signal});
  let need = 'all', skin = 'all';
  function render(updateUrl, withMotion = false) {
    const previous = new Map(cards.filter(card => !card.hidden).map(card => [card, card.getBoundingClientRect()]));
    for (const card of cards) moving.get(card)?.cancel();
    let visible = 0;
    for (const card of cards) {
      const needs = card.dataset.nsNeed.split(' ');
      const skins = card.dataset.nsSkin.split(' ');
      const match = (need === 'all' || needs.includes(need)) && (skin === 'all' || skins.includes(skin) || skins.includes('all'));
      card.hidden = !match;
      if (match) visible++;
    }
    for (const button of needButtons) button.setAttribute('aria-pressed', String(button.dataset.nsNeed === need));
    for (const button of skinButtons) button.setAttribute('aria-pressed', String(button.dataset.nsSkin === skin));
    count.textContent = visible === 1 ? root.dataset.countOne : root.dataset.countMany.replace('{count}', visible);
    empty.hidden = visible !== 0;
    root.querySelector('[data-ns-clear]').hidden = need === 'all' && skin === 'all';
    if (updateUrl) {
      let entering = 0;
      for (const card of cards.filter(card => !card.hidden)) {
        const next = card.getBoundingClientRect();
        if (next.bottom <= 0 || next.top >= innerHeight) continue;
        revealed.add(card);
        if (!withMotion) continue;
        const old = previous.get(card);
        if (old) animate(card, [
          { transform: `translate(${old.left - next.left}px, ${old.top - next.top}px)` },
          { transform: 'translate(0, 0)' }
        ]);
        else animate(card, enter, (entering++ % 4) * 40);
      }
      if (!visible && withMotion) animate(empty, enter);
    }
    if (updateUrl) {
      const url = new URL(location.href);
      for (const [key, value] of [['need', need], ['skin', skin]]) value === 'all' ? url.searchParams.delete(key) : url.searchParams.set(key, value);
      history.replaceState(null, '', url);
    }
  }
  function readUrl() {
    const params = new URLSearchParams(location.search);
    need = needButtons.some(b => b.dataset.nsNeed === params.get('need')) ? params.get('need') : 'all';
    skin = skinButtons.some(b => b.dataset.nsSkin === params.get('skin')) ? params.get('skin') : 'all';
    render(false);
  }
  for (const button of needButtons) button.addEventListener('click', event => { need = button.dataset.nsNeed; render(true, event.detail > 0); });
  for (const button of skinButtons) button.addEventListener('click', event => { skin = button.dataset.nsSkin; render(true, event.detail > 0); });
  for (const button of root.querySelectorAll('[data-ns-reset]')) button.addEventListener('click', event => { need = skin = 'all'; render(true, event.detail > 0); });
  window.addEventListener('popstate', readUrl, {signal: controller.signal});
  readUrl();
  // Content stays visible without JavaScript or IntersectionObserver.
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => {
      let step = 0;
      for (const entry of entries) {
        if (!entry.isIntersecting || entry.target.hidden) continue;
        observer.unobserve(entry.target);
        if (revealed.has(entry.target)) continue;
        revealed.add(entry.target);
        animate(entry.target, enter, (step++ % 4) * 60, 420);
      }
    }, { threshold: 0.08 });
    root.querySelectorAll('.ns-personal > div, .ns-shop-heading, .ns-card, .ns-end-grid > div').forEach(element => observer.observe(element));
  }
  }
  const initWithin = scope => scope.querySelectorAll('[data-noshemet-collection]').forEach(init);
  initWithin(document);
  document.addEventListener('shopify:section:load', event => initWithin(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-noshemet-collection]').forEach(root => {instances.get(root)?.(); instances.delete(root);}));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('[data-noshemet-collection]');
    if (!root) return;
    root.querySelector('[data-ns-reset]').click();
    if (event.target.matches('details')) event.target.open = true;
    event.target.scrollIntoView({block:'center', behavior:'instant'});
  });
})();

// 15.9: the "המארז האישי שלך" tier boxes follow the hub's table (the owner edits it in the hub).
(() => {
  const wrap = document.querySelector('.ns-personal-tiers');
  if (!wrap) return;
  fetch('https://portal.asifcosmetics.co.il/api/bundles/custom?program=' + encodeURIComponent((document.querySelector('[data-cb-program]') || { dataset: {} }).dataset.cbProgram || 'noshemet'), { headers: { Accept: 'application/json' } })
    .then(r => r.ok ? r.json() : null)
    .then(cfg => {
      if (!cfg || !cfg.ok || !cfg.tiers) return;
      const list = Object.entries(cfg.tiers).map(([k, v]) => [Number(k), v]).sort((a, b) => a[0] - b[0]);
      if (!list.length) return;
      wrap.querySelectorAll(':scope > span').forEach(s => s.remove()); // the boxes only, not the number inside the note
      const small = wrap.querySelector('small');
      list.forEach(([count, rate], i) => {
        const span = document.createElement('span');
        const b = document.createElement('b'); b.textContent = rate + '%';
        span.append(b, document.createTextNode(i === list.length - 1 ? count + ' מוצרים ומעלה' : count + ' מוצרים'));
        wrap.insertBefore(span, small);
      });
      if (cfg.maxPerProduct) wrap.querySelectorAll('[data-cb-max-per-product]').forEach(el => { el.textContent = String(cfg.maxPerProduct); });
    })
    .catch(() => {});
})();
